import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentType } from "Models/DocumentType";

interface DocumentTypeState {
  documentTypes: IDocumentType[];
  selectedDocumentTypeId: string | null;
}

const initialState: DocumentTypeState = {
  documentTypes: [],
  selectedDocumentTypeId: null,
};

const documentTypeSlice = createSlice({
  name: "documentTypeState",
  initialState,
  reducers: {
    setDocumentTypes(state, action: PayloadAction<IDocumentType[]>) {
      state.documentTypes = action.payload;
    },
    setSelectedDocumentTypeId(state, action: PayloadAction<string>) {
      state.selectedDocumentTypeId = action.payload;
    },
  },
});

export const { setDocumentTypes, setSelectedDocumentTypeId } = documentTypeSlice.actions;
export default documentTypeSlice.reducer;
